import React from 'react';
import { Redirect, useParams } from 'react-router-dom';

const ConsumerAdvancedSearchRedirect = () => {
  const routerParams = useParams();
  const { query, index, facetFilter } = routerParams;

  const safeQuery = query ?? '';
  const category =
    index?.indexOf('products') !== -1
      ? 'products_jb4'
      : index ?? 'products_jb4';

  return (
    <Redirect
      to={`/search/?q=${encodeURIComponent(
        safeQuery
      )}&category=${category}&filter=${facetFilter ?? '*'}`}
    />
  );
};

export default ConsumerAdvancedSearchRedirect;
